import { render, staticRenderFns } from "./CommunityToys.vue?vue&type=template&id=50f3f308&"
import script from "./CommunityToys.vue?vue&type=script&lang=js&"
export * from "./CommunityToys.vue?vue&type=script&lang=js&"
import style0 from "./CommunityToys.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports